import { inject } from '@angular/core';
import type { CanDeactivateFn } from '@angular/router';
import { PkDialogService } from '../../shared/ui/dialog/dialog.service';
import { AuthService } from '../auth/auth.service';

/** 라우트 이탈 확인 대상 화면이 구현하는 계약 */
export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

function hasUnsavedChangesHook(component: unknown): component is HasUnsavedChanges {
  return (
    typeof component === 'object' &&
    component !== null &&
    typeof (component as Partial<HasUnsavedChanges>).hasUnsavedChanges === 'function'
  );
}

/**
 * 미저장 변경이 있으면 이탈 전에 확인창을 띄운다.
 * 셸 탭 전환은 라우트 전환이라 GridPage의 닫기·초기화 dirty 확인이 걸리지 않는다 — 그 구멍을 메운다.
 * 컴포넌트에 hasUnsavedChanges()가 없거나 false면 통과.
 * 라우트 부착: `canDeactivate: [unsavedChangesGuard]`
 */
export const unsavedChangesGuard: CanDeactivateFn<unknown> = (component) => {
  // 세션 만료로 인한 강제 이탈은 물어보지 않는다 — 사용자가 "취소"를 누르면 토큰만 사라진
  // 화면이 남아 저장도 안 되고 이유도 알 수 없다 (리뷰 C3). 만료는 취소할 수 있는 동작이 아니다
  if (inject(AuthService).sessionExpired()) {
    return true;
  }
  if (!hasUnsavedChangesHook(component) || !component.hasUnsavedChanges()) {
    return true;
  }
  return inject(PkDialogService).confirm('저장하지 않은 변경이 있습니다. 이동할까요?');
};
